
import './index.css';

const Header = () => {
  return (
    <header className="header-section">
      <div className="header-overlay" />
      <div className="header-content">
        <p className="header-label">Welcome to</p>
        <h1 className="header-title">Luxe Unbounded</h1>
        <p className="header-subtitle">
          Where Curated Luxury Meets Boundless Experiences
        </p>
        <p className="header-des">
          Discover a new paradigm in luxury where every experience is thoughtfully curated and every investment is innovative. Luxe Unbounded brings together exclusive living, partial ownership opportunities, and a dynamic community — all designed to redefine luxury beyond wealth alone.
        </p>
      </div>
    </header>
  );
};

export default Header;
